import React from "react";
import { SectionCta } from "../SectionCta";
import { frameworkSteps } from "../../data/clinicalDecisions";
export function FrameworkSection() {
  return <section className="w-full bg-navy px-5 py-16 sm:py-24" data-id="element-205" data-mp="schert52o5np">
      <div className="mx-auto max-w-5xl" data-id="element-206" data-mp="1749s5zlb39ms">
        <p className="text-center text-sm font-bold uppercase tracking-widest text-gold" data-id="element-207" data-mp="175b5kapso87o">The Transformation</p>
        <h2 className="mt-3 text-center font-serif text-[28px] font-black leading-tight text-white sm:text-4xl" data-id="element-208" data-mp="1g469fg5d967t">
          From Scattered Clinical Findings to a Structured Early Orthodontic Assessment
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-lg text-white/80" data-id="element-209" data-mp="1q2vtnfkqj2r8">
          Imagine opening a new pediatric orthodontic case and having a clear sequence to organize your
          thinking. Instead of jumping directly from a clinical finding to an appliance, you follow six
          essential stages:
        </p>

        <h3 className="mt-12 text-center font-serif text-xl font-bold text-white sm:text-2xl" data-id="element-210" data-mp="3mvxmrocukq2f">
          The Early Orthodontic Decision Framework
        </h3>

        <ol className="relative mx-auto mt-8 max-w-2xl lg:grid lg:max-w-none lg:grid-cols-3 lg:gap-5" data-id="element-211" data-mp="1dptrc0f10rfb">
          {frameworkSteps.map((step, i) => <li key={step.number} className="relative flex gap-4 pb-6 lg:block lg:rounded-2xl lg:bg-navy-soft lg:p-6 lg:pb-6" data-id="element-212" data-mp="1inmyavo5lpgn" data-mpi={i}>
              {i < frameworkSteps.length - 1 && <span className="absolute left-[27px] top-14 h-[calc(100%-56px)] w-0.5 bg-navy-line lg:hidden" aria-hidden="true" data-id="element-213" data-mp="1sdy2mjbr20o2" />}
              <span className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-wine font-serif text-xl font-black text-white ring-4 ring-navy lg:ring-navy-soft" data-id="element-214" data-mp="1xfx6rvfbd1m2">
                {step.number}
              </span>
              <div className="pt-1.5 lg:mt-4 lg:pt-0" data-id="element-215" data-mp="72pw8514bvfe">
                <p className="text-lg font-extrabold uppercase tracking-wide text-gold" data-id="element-216" data-mp="740vbrjmcf06">{step.title}</p>
                <p className="mt-1 text-base leading-relaxed text-white/85" data-id="element-217" data-mp="1fbnduujckwsn">{step.text}</p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-10 max-w-2xl space-y-2 text-center" data-id="element-218" data-mp="1advj7srbiwkr">
          <p className="text-lg font-semibold text-white" data-id="element-219" data-mp="1oclinf1m18ca">
            A framework you can revisit whenever you evaluate a growing patient.
          </p>
          <p className="text-white/75" data-id="element-220" data-mp="1jfd0heggp4b1">The goal isn’t to replace your clinical judgment.</p>
          <p className="font-serif text-2xl font-bold text-gold" data-id="element-221" data-mp="1y8og47lioisw">
            It’s to give your clinical judgment a clearer structure.
          </p>
        </div>

        <SectionCta label="Yes! I want a clearer clinical framework" tone="dark" data-id="element-222" data-mp="271rs0bgiknlf" />
      </div>
    </section>;
}